module.exports = __webpack_public_path__ + "tn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tn.svg
// module id = 847
// module chunks = 0